import capitalise from './capitalise';

const ORDINAL_VALUES = [
  'other',
  'first',
  'second',
  'third',
  'fourth',
  'fifth',
  'sixth',
  'seventh',
  'eighth',
  'ninth',
  'tenth',
  'eleventh',
  'twelfth',
];

export default function getOrdinal(n: any, isWhole?: boolean, isCapitalised?: boolean) {
  if (!Number(n)) {
    return;
  }

  if (isWhole && n >= 0 && n < ORDINAL_VALUES.length) {
    const value = ORDINAL_VALUES[n];

    if (isCapitalised) {
      return capitalise(value);
    }

    return value;
  }

  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;

  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}
